export default {
    numeral: true,
    numeralDecimalScale: 2,
    prefix: '$',
    numeralPositiveOnly: true,
    noImmediatePrefix: true,
    rawValueTrimPrefix: true,
}